var _rect, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShopBag(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 16,
    viewBox: "0 0 15 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.5,
    width: 15,
    height: 15,
    fill: "url(#pattern0_592_566)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0_592_566",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_592_566",
    transform: "scale(0.03125)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_592_566",
    width: 32,
    height: 32,
    preserveAspectRatio: "none",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAAACXBIWXMAAA7DAAAOwwHHb6hkAAAAGXRFWHRTb2Z0d2FyZQB3d3cuaW5rc2NhcGUub3Jnm+48GgAAAeRJREFUWIXtl7FKHFEUhv+7mBQGjUZjYSxCxBiJsGIhWJjC3qCF+Ap5gpBXEUJq61SSIoVKYiOKjShZSKFiZdRKUfaz2CO5rPfOzszuoII/DJc959zzfzsz986MdMdyeScCrySVJSFp2zl30DKqBsbDwA+gyn9VgWXgbdHm48CJmZ4AP+04tdg/YKwo86fAHzP6CnR5uW7gm+X2gCdFACyYwS/g1r0DOGDdaubT9i1lYJiycck5R33SYkv280MRAC9tPEqoObSxL23TxGUIvJb0SdIbSZOSBiT9lrQfmTJgdftWV5G06Jz7mxbIN38HnNG8ToHhmE/SJfgiqSMz+W11SvqcB6DcAvMbjecB6GkhwIs8AM8DsTUlr4IDSRuBeFcgFhfQVrfXA+xabhQ4D9xs58B7oATs1uWqQFsWgN6AwQUwavk54NjLHQOzHuBFYH5vFoChyJLavGkEPAOm7Wj3wLcic4eyAExEmkDtgTQDlLz6EvARqCTMmwh5xa5LdwLfoKTvkg6BHYuNSOpv8L+CPWMA0WXjqT+FaUOA2DJMOgN59QjwsADS3IRZFex5b8/AnQNcFgBwlQVgrQCAldSV1D40VhP29axawfuQ8RV9K7aHzZhqe38zqkjacs5Vm+xTjK4BeI99iDpj5loAAAAASUVORK5CYII="
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShopBag);
export default __webpack_public_path__ + "static/media/shop-bag.df7df554e48ade1c87dfd93c53649426.svg";
export { ForwardRef as ReactComponent };